/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import base64Encode from '../../../shared/base64encoder';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {allUploadType} from '../../constants/uploadTypes';

export const uploadFile = async (
  file: any,
  type: allUploadType,
  facility?: string,
  year?: string
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  const companyId = useCompanyStore.getState().companyId;
  const companyDetails = useCompanyStore.getState().companyDetails;

  const userDetails = useUserStore.getState().userDetails;

  try {
    const res = await axios.request({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.uploadFile}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        file: await base64Encode(file).then((result) => {
          return result;
        }),
        company: companyId,
        type,
        facility: facility ?? '',
        fileName: file.name,
        user: userDetails._id,
        subCategory: companyDetails.subCategory,
        year: year ?? '',
        fiscalYear: companyDetails?.fiscalYear
      }
    });

    return res.data;
  } catch (err) {
    return err;
  }
};
